import { useQuery, useMutation } from '@apollo/client';
import {
    getProductionValueStepsTemplate,
    addProductionValueStepTemplate,
    updateProductionValueStepTemplate,
    deleteProductionValueStepTemplate,
} from 'apollo/templates/organization';
import { ProductionValueStep } from 'models/organization';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';

export const useProductionValueSteps = () => {
    const { showBoundary } = useDenthubErrorBoundary();

    const { data, loading: productionValueStepsLoading, refetch } = useQuery(getProductionValueStepsTemplate);

    const [addStep, { loading: addStepLoading }] = useMutation(addProductionValueStepTemplate);
    const addProductionValueStep = async (variables: { step: Omit<ProductionValueStep, '_id'> }) => {
        try {
            const result = await addStep({ variables });
            refetch();
            return result.data.addProductionValueStep;
        } catch (error) {
            showBoundary(error);
        }
    };

    const [editStep, { loading: editStepLoading }] = useMutation(updateProductionValueStepTemplate);
    const updateProductionValueStep = async (variables: { stepId: string; step: Omit<ProductionValueStep, '_id'> }) => {
        try {
            const result = await editStep({ variables });
            refetch();
            return result.data.updateProductionValueStep;
        } catch (error) {
            showBoundary(error);
        }
    };

    const [deleteStep, { loading: deleteStepLoading }] = useMutation(deleteProductionValueStepTemplate, {
        onCompleted() {
            refetch();
        },
        onError(error) {
            showBoundary(error);
        },
    });

    const deleteProductionValueStep = async (variables: { stepId: string }) => {
        return deleteStep({ variables }).then((result) => result.data?.deleteProductionValueStep);
    };

    return {
        productionValueSteps: (data?.productionValueSteps ?? []) as ProductionValueStep[],
        productionValueStepsLoading,
        refetchProductionValueSteps: refetch,

        addProductionValueStep,
        updateProductionValueStep,
        deleteProductionValueStep,

        addStepLoading,
        editStepLoading,
        deleteStepLoading,
    };
};
